<template>
    <h1 class="">RFID Piece Up</h1>
    <audio src="/resources/audio/success.wav" autostart="false" loop="false" hidden="true" width="0" height="0"
        id="audio_success" />
    <audio src="/resources/audio/error.wav" autostart="false" loop="false" hidden="true" width="0" height="0"
        id="audio_error" />
    <audio src="/resources/audio/multiple.wav" autostart="false" loop="false" hidden="true" width="0" height="0"
        id="audio_multiple" />

    <div id="page-rfid-pieceup" class="content-section">
        <div class="page-section">

            <div class="content-section">
                <div class="row">
                    <div class="col-md-12">

                        <div class="d-flex align-items-center " style="min-height: 60px;">
                            <div class="col-md-5"></div>

                            <div v-if="isBulkScan" class="alert alert-danger p-2">Warning: Bulk Scan Activated</div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="rfid-action-buttons">
                        <FormKit type="button" label="Go Back"
                            input-class="$reset btn-rfid-smlg btn btn-rfid btn-associate btn-goback"
                            @click="goTo('Dashboard')" prefix-icon="arrowLeft" prefix-icon-class="btn-rfid-back" />
                        <FormKit type="button" label="Start Scan"
                            input-class="$reset  btn-rfid-smlg btn btn-rfid btn-re-assign" @click="goTo('startScan')"
                            :disabled="!canSartScan ? true : false" />
                        <FormKit type="button" label="Start BULK Scan"
                            input-class="$reset  btn-rfid-smlg btn btn-rfid btn-de-assign"
                            @click="goTo('startBulkScan')" :disabled="!canStartBulkScan ? true : false" />
                        <FormKit type="button" label="Stop Scan"
                            input-class="$reset  btn-rfid-smlg btn btn-rfid btn-stop-scan  " @click="goTo('StopScan')"
                            :disabled="!canStopScan ? true : false" />
                        <FormKit type="button" label="Clear"
                            input-class="$reset  btn-rfid-smlg btn btn-rfid btn-associate" @click="goTo('Reset')"
                            :disabled="!canReset || isResetting ? true : false" />
                    </div>
                </div>
            </div>

            <div class="content-section" v-if="canScanCode">
                <FormKit v-model="scanCode" type="text" name="scanCode" id="scanCodeInput"
                    placeholder="Scan Code" aria-autocomplete="none" autocomplete="off" autofocus />
                <div :class="scanCodeClass" style="min-height:1.5em;">{{ scanCodeHint}}</div>
                <!--<div class="alert alert-danger mt-3">
                <div v-html="error_message_scan"></div>
                </div>-->
            </div>

            <div class="content-section" v-if="canScanTicket">
                <FormKit v-model="serviceTicketCode" type="text" name="serviceTicketCode" id="serviceTicketCodeInput"
                    placeholder="Service Ticket Code" aria-autocomplete="none" autocomplete="off" autofocus />
                <div :class="scanServiceTicketClass">{{ scanServiceTicketHint }}</div>
                <!--<div class="alert alert-danger mt-3" v-if="error_message_service_ticket">
                    <div v-html="error_message_service_ticket"></div>
                </div>-->
                <!-- DEBUG: Show state of alert conditions -->
                        <div class="alert alert-warning mt-3 text-center" v-if="currentBulkOrder && canStopBulkScan && canScanTicket">
                            <div> Scan Service Ticket again in order to Stop Bulk Scan</div>
                        </div>
            </div>
            <!-- Warning Bubble -->
            <div v-if="showSseErrors" class="warning-bubble">
                {{ sseErrors }}
            </div>

             <!-- Error Bubble -->
            <div v-if="showErrorBubble" class="warning-bubble">
                {{ errorMessage }}
            </div>
             <!-- Success Bubble -->
            <div v-if="showSuccessBubble" class="success-bubble">
                {{ successMessage }}
            </div>

            <!-- Warning Bubble -->
            <div v-if="showWarningBubble" class="warning-bubble">
                Garment waiting to be pieced up
            </div>

             <!-- QC Fail Bubble -->
            <div v-if="showQcFailBubble" class="qc-fail-bubble">
                {{ qcFailMessage }}
            </div>

            <!-- New Assignment Bubble -->
            <div v-if="showNewAssignmentBubble" class="new-assignment-bubble">
                This is a new assignment, please attach the printed service ticket to the smart shelf.
            </div>

            <!-- Completes Ticket Bubble -->
            <div v-if="showCompletesTicketBubble" class="completes-ticket-bubble">
                This garment will complete the service ticket.
            </div>

            <!-- No Order Bubble -->
            <div v-if="showNoOrderBubble" class="no-order-bubble">
                This garment doesn't belong to any open order.
            </div>

            <!-- Not Found Bubble -->
            <div v-if="showNotFoundBubble" class="not-found-bubble">
                This garment doesn't exist, clear and try again.
            </div>

            <!-- Invalid Ticket Bubble -->
            <div v-if="showInvalidTicketBubble" class="invalid-ticket-bubble">
                <span v-if="!error_message_service_ticket">
                    Invalid service ticket scanned. Please make sure you placed
                    the garment in the correct shelf and scan
                    again.</span>
                {{ error_message_service_ticket }}
            </div>

            <!-- Show order/garments details-->
            <div v-if="currentBulkOrder" :class="['bulk-scan-layout', { 'bulk-scan-layout--active': isBulkScan }]">
                <div :class="['garment-info', { 'garment-info--bulk': isBulkScan }]">
                    <div class="garment-info-grid">
                        <div class="info-row">
                            <span class="info-label">Order ID:</span>
                            <span class="info-value">
                                <router-link
                                    v-if="currentBulkOrder?.service_ticket?.order_id"
                                    target="_blank"
                                    :to="{ name: 'ViewOrder', params: { id: currentBulkOrder.service_ticket.order_id } }">
                                    <div>{{ currentBulkOrder.service_ticket.order_id }}</div>
                                </router-link>
                            </span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Customer Name:</span>
                            <span class="info-value">
                                <router-link
                                    v-if="currentBulkOrder?.order_info?.customer_id"
                                    target="_blank"
                                    :to="{ name: 'ViewCustomer', params: { id: currentBulkOrder.order_info.customer_id } }">
                                    <div>{{ currentBulkOrder.order_info.customer_name }}</div>
                                </router-link>
                            </span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Item Count:</span>
                            <span class="info-value">{{ itemsApplied.length }} / {{ currentBulkOrder?.ticket_items?.length }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Due Date:</span>
                            <span class="info-value">{{ formatDateYMD(currentBulkOrder?.order_info?.date_due) }}</span>
                        </div>
                    </div>
                </div>

                <div v-if="isBulkScan" class="bulk-scan-table-panel">
                    <div class="bulk-scan-table-header">
                        <div>
                            <h3 class="bulk-scan-table-title">Scanned Garments</h3>
                            <p class="bulk-scan-table-subtitle">Visible for 10 seconds after the latest scan.</p>
                        </div>
                        <button
                            type="button"
                            class="btn btn-sm bulk-scan-clear-btn"
                            @click="clearBulkScanTable"
                            :disabled="tagsScanned.length === 0"
                        >
                            Clear
                        </button>
                    </div>
                    <div class="bulk-scan-table-shell">
                        <table class="bulk-scan-table">
                            <thead>
                                <tr>
                                    <th>Count</th>
                                    <th>Garment Type</th>
                                    <th>Timestamp</th>
                                </tr>
                            </thead>
                            <tbody v-if="tagsScanned.length">
                                <tr
                                    v-for="scan in tagsScanned"
                                    :key="scan.epcscanned"
                                    :class="['bulk-scan-row', getGarmentTypeColorClass(scan.garmentType)]"
                                >
                                    <td>{{ scan.garmentindex }}</td>
                                    <td>{{ scan.garmentType }}</td>
                                    <td>{{ scan.tagtimestamp }}</td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td colspan="3" class="bulk-scan-empty-state">Waiting for scanned garments.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div v-if="showOrderDetails" class="garment-info">
                <div class="garment-info-grid">
                    <div class="info-row">
                        <span class="info-label">Garment Scanned:</span>
                        <span class="info-value">{{ currentScan?.Type }}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Customer Name:</span>
                        <span class="info-value">
                            <router-link v-if="orderDetails?.customer_id" target="_blank"
                                :to="{ name: 'ViewCustomer', params: { id: orderDetails?.customer_id } }">
                                <div>{{ orderDetails?.customername }}</div>
                            </router-link>
                        </span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Order ID:</span>
                        <span class="info-value">
                            <router-link v-if="orderDetails?.order_id" target="_blank"
                                :to="{ name: 'ViewOrder', params: { id: orderDetails?.order_id } }">
                                <div>{{ orderDetails?.order_id }}</div>
                            </router-link>
                        </span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Due Date:</span>
                        <span class="info-value">
                            {{ formatDateYMD(orderDetails?.datedue) }}
                            <span v-if="currentScan?.express" class="express-flag">EXP</span>
                        </span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Garment ID:</span>
                        <span class="info-value">
                            <router-link v-if="currentScan?.ID" target="_blank"
                                :to="{ name: 'ViewGarment', params: { id: currentScan?.ID } }">
                                <div>{{ currentScan?.ID }}</div>
                            </router-link>
                        </span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">EPC:</span>
                        <span class="info-value">{{ currentScan?.EPC }}</span>
                    </div>
                </div>
                
                <!-- QC Fail Buttons -->
                <div v-if="!currentScan.no_order && !currentScan.not_found" class="qc-buttons">
                <button 
                    class="btn btn-fail-cleaning"
                    @click.stop="failQcCleaning"
                >
                    Fail QC (Cleaning)
                </button>
                <button 
                    class="btn btn-fail-repair"
                    @click.stop="failQcRepair"
                >
                    Fail QC (Repair)
                </button>
                </div>
            </div>
            
        </div>
    </div>


    <div class="modal" tabindex="-1" id="showAlertMessagesModal" ref="showAlertMessagesModal" data-bs-backdrop="static">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Attention!</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="alert alert-warning">
                        <div v-html="alertMessage"></div>
                    </div>
                    <div class="alert alert-danger" v-if="hasMultipleScans">
                        Multiple tags scanned! Please check the list of scanned tags.
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">OK</button>

                </div>
            </div>
        </div>
    </div>

    <div class="modal" tabindex="-1" id="showErrorMessagesModal" ref="showErrorMessagesModalEl"
        data-bs-backdrop="static">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header" v-if="errorMessageTitle">
                    <h5 class="modal-title">{{ errorMessageTitle }}</h5>
                </div>
                <div class="modal-body">
                    
                    <p class="modal-message">{{ alertMessage }}</p>

                    <div>
                        <p class="modal-note">Please note: None of these items have been pieced up</p>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal">CLOSE</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Invalid Garments Modal -->
      <div class="modal" tabindex="-1" id="showInvalidGarmentsModal" ref="showInvalidGarmentsModalEl"
        data-bs-backdrop="static">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-body">
                    <p class="modal-message">The scanned items contain the following which does not belong to the service ticket:</p>
          
                    <ul class="invalid-garments-list">
                        
                        <li v-for="(garment, index) in bulkInvalidGarments" :key="index">
                            <div v-if="!garment.garment_id"><span>- EPC: {{ garment.tag }}</span></div>
                                <div v-if="garment?.garment_id || garment?.customer_id" ><span class="garment-link">
                                    <router-link v-if="garment?.garment_id" target="_blank"
                                        :to="{ name: 'ViewGarment', params: { id: garment?.garment_id } }">
                                        {{ garment.garment_type }}
                                    </router-link>
                                </span>
                                -
                                <router-link v-if="garment?.customer_id" target="_blank"
                                    :to="{ name: 'ViewCustomer', params: { id: garment?.customer_id } }">
                                    {{ garment?.customer_name }}
                                </router-link>
                            </div>
                        </li>
                    </ul>

                    <div>
                        <p class="modal-note">Please note: None of these items have been pieced up</p>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal">CLOSE</button>
                </div>
            </div>
        </div>
    </div>
   
</template>


<script setup>
import { onMounted, ref, watch, nextTick } from 'vue';
import * as bootstrap from 'bootstrap';
import RFIDService from "@/services/RFIDService";
import OrderService from "@/services/OrderService";
//import { printServiceTicket } from './printServiceTicketHelper';
import ServiceTicket from '@/services/ServiceTicketService.js';
import { barcodePatterns } from '@/utils/orderUtils';
import { formatLondon, formatDateYMD } from '@/utils/dateUtils';
import { getBarcodeDetails } from '@/utils/orderUtils';
import { openModal } from '@/utils/modalUtils';
import VueCookies from "vue-cookies";
import Order from '@/models/Order';
import e from 'cors';

const scanCode = ref("");
const scanCodeHint = ref("Scan Garment");
const scanCodeClass = ref("success-message");
const serviceTicketCode = ref("");
const showErrorMessagesModalEl = ref(null);
const showInvalidGarmentsModalEl = ref(null);
let invalidGarmentsModalInstance = null;
const workflowMode = ref(null);
const scanServiceTicketClass = ref('success-message');
const scanServiceTicketHint = ref('Scan Service Ticket');

const canApply = ref(false);
const canSartScan = ref(true);
const canStartBulkScan = ref(true);
const canStopScan = ref(false);
const canReset = ref(false);
const isResetting = ref(false);
const canScanCode = ref(true);
const canScanTicket = ref(false);
const canStopBulkScan = ref(false);
const error_message_scan = ref("");
const error_message_service_ticket = ref("");
const showOrderDetails = ref(false);
const orderDetails = ref({});
const currentScan = ref({});
const currentBulkOrder = ref(null);
const showSseErrors = ref(false);
const sseErrors = ref("");
const showSuccessBubble = ref(false);
const successMessage = ref("");
const showErrorBubble = ref(false);
const errorMessage = ref("");
const showWarningBubble = ref(false);
const showQcFailBubble = ref(false);
const qcFailMessage = ref("");
const showNewAssignmentBubble = ref(false);
const showCompletesTicketBubble = ref(false);
const showNoOrderBubble = ref(false);
const showNotFoundBubble = ref(false);
const showInvalidTicketBubble = ref(false);
// Track if the RFID scan stream is active
const isStreamActive = ref(false);
const itemsApplied = ref([]);
const tagsScanned = ref([]);
const isBulkScan = ref(false);
const hasMultipleScans = ref(false);
const singleScanAllowed = ref(true);
const totalTags = ref(0);
const alertMessage = ref("");
const errorMessageTitle = ref("Error");
const currentServiceTicket = ref(null);
const bulkScanStep = ref(1); //1 = waiting for ticket, 2 = waiting for stop scan
const bulkInvalidGarments = ref([]);
let eventSource = null;
const isPrinting = ref(false);
const bulkServiceTicketBarcode = ref(null);
let bulkScanTableTimer = null;

const garmentTypeColorClasses = [
    'bulk-scan-type-0',
    'bulk-scan-type-1',
    'bulk-scan-type-2',
    'bulk-scan-type-3',
    'bulk-scan-type-4',
    'bulk-scan-type-5'
];

const playSound = (soundtype) => {
  let sound = document.getElementById("audio_"+soundtype);
  sound.currentTime = 0;
  sound.loop = false;
  sound.play();
}

function createOrderDetailsModel(source = {}, isError = false) {
    const customerName = source?.customer_name
        || source?.customername
        || [source?.customer?.first_name, source?.customer?.last_name].filter(Boolean).join(' ');
    const customerId = source?.customer_id ?? source?.customerid ?? source?.customer?.id ?? null;
    let orderId = source?.order_id ?? source?.id ?? '';
    let dateCollectValue = source?.order_collect_date ?? source?.date_collect ?? source?.datecollect ?? '';
    let dateDueValue = source?.order_due_date ?? source?.date_due ?? source?.datedue ?? '';

    if (isError) {
        orderId = '';
        dateCollectValue = '';
        dateDueValue = '';
    }
    return {
        customer_id: customerId,
        customername: customerName || '',
        order_id: orderId,
        datecollect: dateCollectValue ? formatDateYMD(dateCollectValue) : '',
        datedue: dateDueValue ? formatDateYMD(dateDueValue) : ''
    };
}

// Helper to set order and scan details
function setOrderAndScanDetails(orderObj, orderItemObj, garmentObj, tempTagObj=null) {
    showOrderDetails.value = true;
    orderDetails.value = createOrderDetailsModel(orderObj);
    currentScan.value = {
        ID: garmentObj?.garment_id,
        Type: orderItemObj?.garment_type?.garment_type,
        OrderItem: orderItemObj?.id,
        EPC: garmentObj?.rfid_value || tempTagObj?.rfid_value || '',
        express: orderObj?.next_day === true ? true : false
    };
    currentServiceTicket.value = orderItemObj?.service_ticket?.serviceticket_id;
}
// Utility to clear scan input and show error message
function clearInputAndShowError(message, type = "scan") {
    if (type === "scan") {
        scanCode.value = "";
        scanCodeHint.value = message;
        scanCodeClass.value = "error-message";
        focusElement('scanCodeInput');
    } else if (type === "serviceTicket") {
        serviceTicketCode.value = "";
        scanServiceTicketHint.value = message;
        scanServiceTicketClass.value = "error-message";
        focusElement('serviceTicketCodeInput');
    }
}

// Utility to clear input and show success message
function clearInputAndShowSuccess(message, type = "scan") {
    if (type === "scan") {
        scanCode.value = "";
        //scanCodeHint.value = message;
        scanCodeClass.value = "success-message";
        focusElement('scanCodeInput');
    } else if (type === "serviceTicket") {
        serviceTicketCode.value = "";
        //scanServiceTicketHint.value = message;
        scanServiceTicketClass.value = "success-message";
        focusElement('serviceTicketCodeInput');
    }
    successMessage.value = message;
    showSuccessBubble.value = true;
    setTimeout(() => {
        showSuccessBubble.value = false;
        successMessage.value = '';
    }, 10000);
}
// Utility to clear scanCode and optionally hide input
function clearScanCode(status = "success", hide = "") {
    scanCode.value = "";
    if (status === "success") {
        scanCodeHint.value = "Scan Garment";
        scanCodeClass.value = "success-message";
    } else {
        scanCodeHint.value = "";
        scanCodeClass.value = "";
    }
    if (hide === "hide") {
        canScanCode.value = false;
    } else {
        canScanCode.value = true;
    }
}
function clearServiceTicketCode(status = "success", hide = "") {
    serviceTicketCode.value = "";
    if (status === "success") {
        scanServiceTicketHint.value = "Scan Service Ticket";
        scanServiceTicketClass.value = "success-message";
    } else {
        scanServiceTicketHint.value = "";
        scanServiceTicketClass.value = "";
    }
    if (hide === "hide") {
        canScanTicket.value = false;
    } else {
        canScanTicket.value = true;
    }
}

const printServiceTicket = (orderID, serviceTicketID) => {
  if (isPrinting.value) return; // Prevent multiple clicks if already processing
  isPrinting.value = true; // Disable the button

    OrderService.printServiceTickets(orderID, {tickets: [serviceTicketID], bedding:true, towel_folding:false})
    .then(response => {
      if (response.data.success === true) {
        console.log("Service ticket printed successfully.");
      } else {
        alert("Error printing service ticket: " + response.data.message);
        console.log("Error printing service ticket: " + response.data.message);
      }
    })
    .catch(e => {
      alert("Error printing service ticket: " + e);
      console.log("Error printing service ticket: " + e);
    }).finally(() => {
      isPrinting.value = false; // Re-enable the button in all cases
    });
    
}
// --- Modularized scanCode watcher handlers ---
async function handleGarmentScan(barcodeDetails, newValue) {
    hideAllBubbles();
    workflowMode.value = 'ad-hoc';
    try {
        const response = await OrderService.getGarmentDetailsByTag(barcodeDetails.barcode, 'pieceup');
        console.log('[DEBUG hideAllBubbles] getGarmentDetailsByTag response:', response);
        const garmentDetails = response && response.data && response.data.data ? response.data.data : null;
        if (!garmentDetails || !garmentDetails.garment || !garmentDetails.garment.garment_id) {
            //errorMessage.value = "Error fetching scanned garment details: No data returned.";
            errorMessage.value = ""
            showNotFoundBubble.value = true;
            playSound('error');
            clearScanCode("success");
            scanCode.value = '';
            canReset.value = true;
            //setTimeout(() => { showNotFoundBubble.value = false; errorMessage.value = ""; }, 4000);
            return;
        }
        setOrderAndScanDetails(garmentDetails.order, garmentDetails.order_item, garmentDetails.garment);
        scanCode.value = '';
        canScanCode.value = false;
        canScanTicket.value = true;
        scanServiceTicketClass.value = 'success-message';
        scanServiceTicketHint.value = 'Scan Service Ticket';
        if (garmentDetails.piece_up && garmentDetails.piece_up.is_first_assignment == 1) {
            //showNewAssignmentBubble.value = true;
            console.log('[DEBUG] getGarmentDetailsByTag OrderID:', garmentDetails.order.id);
            //await printServiceTicket(garmentDetails.order.id);
              await isNewAssignment(garmentDetails.order.id, garmentDetails?.order_item?.service_ticket?.serviceticket_id);
        }
        if (garmentDetails.piece_up && garmentDetails.piece_up.will_complete == 1) {
            showCompletesTicketBubble.value = true;
        }
        playSound('success');
        itemsApplied.value.push(garmentDetails.order_item.id);
        scanCode.value = '';
    } catch (e) {
        const errMsg = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : JSON.stringify(e);
        errorMessage.value = "Error fetching scanned garment details: " + errMsg;
        const errorCode = e && e.response && e.response.data && e.response.data.code ? e.response.data.code : null;
        if (errorCode === 'GARMENT_NOT_IN_ORDER') {
            showGarmentNotInOrderDetails(e.response.data);
            playSound('error');         
            scanCode.value = '';
            return;
        } else if (errorCode === 'GARMENT_LOAD_ERROR' || errorCode === 'GARMENT_NOT_FOUND') {
            showNotFoundBubble.value = true;
        } else if (errorCode === 'ORDER_COMPLETED') {
            showNoOrderBubble.value = true;
        } else {
            showErrorBubble.value = true;
        }
        scanCode.value = '';
        canReset.value = true;
        /*setTimeout(() => { 
            showNotFoundBubble.value = false; 
            showNoOrderBubble.value = false; 
            showErrorBubble.value = false; 
            errorMessage.value = ""; 
        }, 3000);*/
        console.log(e);
        playSound('error');
    }
}

async function handleItemScan(barcodeDetails, newValue) {
    hideAllBubbles();
     workflowMode.value = 'ad-hoc';
    try {
        const response = await OrderService.getOrderItemDetails(barcodeDetails.id, 'pieceup');
        console.log('[DEBUG handleItemScan] getOrderItemDetails response:', response);
        const itemDetails = response && response.data && response.data.data ? response.data.data : null;
        //item can have temporary garments, means garment details might not be available at this point
        setOrderAndScanDetails(itemDetails?.order, itemDetails?.order_item, itemDetails?.order_item?.garment, itemDetails?.temp_tag);
        scanCode.value = '';
        canScanCode.value = false;
        canScanTicket.value = true;
        scanServiceTicketClass.value = 'success-message';
        scanServiceTicketHint.value = 'Scan Service Ticket';
        if (itemDetails?.piece_up && itemDetails.piece_up.is_first_assignment == 1) {
            //showNewAssignmentBubble.value = true;
            console.log('[DEBUG] getOrderItemDetails OrderID:', itemDetails?.order?.id);
             await isNewAssignment(itemDetails?.order?.id, itemDetails?.order_item?.service_ticket?.serviceticket_id);
            //await printServiceTicket(itemDetails?.order?.id);
        }
        if (itemDetails?.piece_up && itemDetails.piece_up.will_complete == 1) {
            showCompletesTicketBubble.value = true;
        }
        playSound('success');
        itemsApplied.value.push(itemDetails?.order_item?.id);
        scanCode.value = '';
    } catch (e) {
        const errMsg = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : JSON.stringify(e);
        errorMessage.value = "Error fetching scanned item details: " + errMsg;
        const errorCode = e && e.response && e.response.data && e.response.data.code ? e.response.data.code : null;
        if (errorCode === 'GARMENT_NOT_IN_ORDER') {
            showGarmentNotInOrderDetails(e.response.data);
            playSound('error');         
            scanCode.value = '';
            return;
        } else if (errorCode === 'GARMENT_LOAD_ERROR' || errorCode === 'GARMENT_NOT_FOUND') {
            showNotFoundBubble.value = true;
        } else if (errorCode === 'ORDER_COMPLETED') {
            showNoOrderBubble.value = true;
        } else {
            showErrorBubble.value = true;
        }
        scanCode.value = '';
        canReset.value = true;
        /*setTimeout(() => { 
            showNotFoundBubble.value = false; 
            showNoOrderBubble.value = false; 
            showErrorBubble.value = false; 
            errorMessage.value = ""; 
        }, 3000); */
        console.log(e);
        playSound('error');
    }
}
function showGarmentNotInOrderDetails(errorData) {
    showNoOrderBubble.value = true;
    //show details of the order item not found in the order in the error bubble
    showOrderDetails.value = true;
    orderDetails.value = createOrderDetailsModel(errorData.data, true);
   
    currentScan.value = {
        ID: errorData.data.garment_id,
        Type: errorData.data.garment_type,
        OrderItem: errorData.data.order_item_id,
        EPC: errorData.data.epc || errorData.data.tag,
        //hide qc buttons if garment not in order
        no_order: true,
        not_found: true
    }
}
async function handleRfidHexScan(barcodeDetails, newValue) {
    hideAllBubbles();
     workflowMode.value = 'ad-hoc';
    let garmentDetails = null;
    let errorCode = null;
    let errMsg = null;
    let errorData = null;
    try {
        // First attempt: getGarmentRFIDDetails
        const response = await OrderService.getGarmentRFIDDetails(barcodeDetails.id, 'pieceup');
        if (response && response.data && response.data.data) {
            garmentDetails = response.data.data;
        } else {
            // If no data, treat as error
            errorCode = 'GARMENT_LOAD_ERROR';
        }
    } catch (e) {
        // If error, check if it's GARMENT_LOAD_ERROR
        errorCode = e && e.response && e.response.data && e.response.data.code ? e.response.data.code : null;
        errMsg = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : JSON.stringify(e);
        errorData = e && e.response && e.response.data ? e.response.data : null;
    }
   
    if (errorCode == "GARMENT_NOT_IN_ORDER") {
        showGarmentNotInOrderDetails(errorData);
        playSound('error');         
        scanCode.value = '';
        return;
   }
    // If first call failed with GARMENT_LOAD_ERROR, try getTagRFIDDetails
    if (!garmentDetails && errorCode === 'GARMENT_LOAD_ERROR') {
        try {
            const tempResponse = await OrderService.getTagRFIDDetails(barcodeDetails.id, 'pieceup');
            if (tempResponse && tempResponse.data && tempResponse.data.data) {
                garmentDetails = tempResponse.data.data;
            } else {
                errorCode = tempResponse && tempResponse.data && tempResponse.data.code ? tempResponse.data.code : 'GARMENT_LOAD_ERROR';
            }
             
        } catch (e2) {
            errorCode = e2 && e2.response && e2.response.data && e2.response.data.code ? e2.response.data.code : null;
            errMsg = e2 && e2.response && e2.response.data && e2.response.data.message ? e2.response.data.message : JSON.stringify(e2);
            errorData = e2 && e2.response && e2.response.data ? e2.response.data : null;
        }
    }
   
    if (garmentDetails) {
        setOrderAndScanDetails(garmentDetails?.order, garmentDetails?.order_item, garmentDetails?.garment || garmentDetails?.tempTag);
        scanCode.value = '';
        canScanCode.value = false;
        canScanTicket.value = true;
        scanServiceTicketClass.value = 'success-message';
        scanServiceTicketHint.value = 'Scan Service Ticket';
        if (garmentDetails?.piece_up && garmentDetails.piece_up.is_first_assignment == 1) {
            //showNewAssignmentBubble.value = true;
            //await printServiceTicket(garmentDetails?.order?.id);
            await isNewAssignment(garmentDetails?.order?.id, garmentDetails?.order_item?.service_ticket?.serviceticket_id);
        }
        if (garmentDetails?.piece_up && garmentDetails.piece_up.will_complete == 1) {
            showCompletesTicketBubble.value = true;
        }
        playSound('success');
        itemsApplied.value.push(garmentDetails?.order_item?.id);
        scanCode.value = '';
        return;
    } else {
        // If both calls failed, show error bubbles
        console.log("DEBUG errorCode:", errorCode);
        console.log("DEBUG errMsg:", errMsg);

        errorMessage.value = errMsg ? ("Error fetching scanned garment details: " + errMsg) : "Error fetching scanned garment details.";
        if (errorCode == "GARMENT_NOT_IN_ORDER") {
            console.log("DEBUG errorData:", errorData);
            showGarmentNotInOrderDetails(errorData);
        } else if (errorCode === 'GARMENT_LOAD_ERROR' || errorCode === 'GARMENT_NOT_FOUND') {
            showNotFoundBubble.value = true;
        } else if (errorCode === 'ORDER_COMPLETED') {
            showNoOrderBubble.value = true;
        } else {
            showErrorBubble.value = true;
        }
        scanCode.value = '';
        canReset.value = true;
        /*setTimeout(() => {
            showNotFoundBubble.value = false;
            showNoOrderBubble.value = false;
            showErrorBubble.value = false;
            errorMessage.value = '';
        }, 3000);*/
        playSound('error');
    }
}

watch(() => scanCode.value, async (newValue) => {
        // Clear invalid scan code message on every input change
        if (scanCodeHint.value && scanCodeHint.value.startsWith('Invalid Scan Code')) {
            scanCode.value = '';
            scanCodeHint.value = 'Scan Garment';
            scanCodeClass.value = 'success-message';
            focusElement('scanCodeInput');
        }
    if (!workflowMode.value) {
        workflowMode.value = 'ad-hoc';
    }
    if (!newValue || newValue.length === 0) {
        error_message_scan.value = '';
        return;
    }
    hideAllBubbles();
    showOrderDetails.value = false;
    currentBulkOrder.value = null;
    canReset.value = true;
    let barcodeDetails = getBarcodeDetails(scanCode.value, barcodePatterns);
    console.log("Scanned code details:", barcodeDetails);
    if (!barcodeDetails.id || (barcodeDetails.type !== "garment" && barcodeDetails.type !== "item" && barcodeDetails.type !== "rfid-hex")) {
        scanCode.value = '';
        await nextTick();
        // Directly clear the FormKit input DOM value as a workaround
        const scanInput = document.getElementById('scanCodeInput');
        if (scanInput) scanInput.value = '';
        playSound('error');
        canReset.value = false;
        //clearInputAndShowError("Invalid Scan Code: " + newValue, "scan");
        return;
    }
    if (barcodeDetails.type === "garment") {
        await handleGarmentScan(barcodeDetails, newValue);
        scanCode.value = '';
        focusElement('serviceTicketCodeInput');
        return;
    }
    if (barcodeDetails.type === "item") {
        await handleItemScan(barcodeDetails, newValue);
        scanCode.value = '';
        focusElement('serviceTicketCodeInput');
        return;
    }
    if (barcodeDetails.type === "rfid-hex") {
        await handleRfidHexScan(barcodeDetails, newValue);
        scanCode.value = '';
        focusElement('serviceTicketCodeInput');
        return;
    }
});

watch(() => serviceTicketCode.value, (newValue) => {
        // Clear invalid service ticket message on every input change
        if (scanServiceTicketHint.value && scanServiceTicketHint.value.startsWith('Invalid Service Ticket barcode')) {
            serviceTicketCode.value = '';
            scanServiceTicketHint.value = 'Scan Service Ticket';
            scanServiceTicketClass.value = 'success-message';
            focusElement('serviceTicketCodeInput');
        }
    if (!newValue || newValue.length === 0) {
        error_message_service_ticket.value = '';
        return;
    }
     errorMessage.value = '';
    showErrorBubble.value = false;
    
    let barcodeDetails = getBarcodeDetails(serviceTicketCode.value, barcodePatterns);
    if (barcodeDetails.type !== "ticket" && barcodeDetails.type !== "ticket_order") {
        serviceTicketCode.value = '';
        scanServiceTicketHint.value = 'Scan Service Ticket';
        scanServiceTicketClass.value = 'success-message';
        nextTick(() => {
            const ticketInput = document.getElementById('serviceTicketCodeInput');
            if (ticketInput) ticketInput.value = '';
        });
        focusElement('serviceTicketCodeInput');
        errorMessage.value = 'Scan a valid Service Ticket barcode.';
        showErrorBubble.value = true;
        playSound('error');
        return;
    }
    if (!barcodeDetails.id) {
        serviceTicketCode.value = '';
        nextTick(() => {
            const ticketInput = document.getElementById('serviceTicketCodeInput');
            if (ticketInput) ticketInput.value = '';
        });
        playSound('error');
        //clearInputAndShowError("Invalid Service Ticket barcode: " + newValue, "serviceTicket");
        return;
    }
    console.log("Service ticket scanned with workflow mode:", workflowMode.value);
    console.log("bulkScanStep:", bulkScanStep.value);

    //itemsApplied need to have unique values
    if (itemsApplied.value && itemsApplied.value.length > 0) {
        itemsApplied.value = [...new Set(itemsApplied.value)];
    }

    // Scenario 1: Bulk Scan
    if (workflowMode.value === 'bulk') {
        singleScanAllowed.value = false; // Disable single scan mode when in bulk workflow
        if (bulkScanStep.value === 1) {
            bulkServiceTicketBarcode.value = newValue; // Store the raw barcode value for later use
            console.log("Bulk scan - bulkServiceTicketBarcode - step1:", bulkServiceTicketBarcode.value);
            getServiceTicketOrder(newValue, false).catch((e) => {
                if (e && e.response && e.response.status === 400) {
                    hideAllBubbles();
                    playSound('error');
                    canReset.value = true;
                    showInvalidTicketBubble.value = true;
                    error_message_service_ticket.value = e.response.data?.message || 'Invalid service ticket.';
                } else {
                    errorMessage.value = e?.message || e;
                    showErrorBubble.value = true;
                    canReset.value = true;
                    //setTimeout(() => { showErrorBubble.value = false; errorMessage.value = ""; }, 4000);
                }
                serviceTicketCode.value = '';
                focusElement('serviceTicketCodeInput');
                    
            });
            bulkScanStep.value = 2;
            canScanTicket.value = true;
            //start reader
                RFIDService.startScan().then(() => {
                    isStreamActive.value = false;
                    canStopScan.value = true; // Enable Stop Scan button when stream starts
                    canSartScan.value = false; // Disable Start Scan button when stream starts
                    canStartBulkScan.value = false; // Disable Start Bulk Scan button when stream starts
                }).catch((e) => {
                    errorMessage.value = e?.message || e;
                    showErrorBubble.value = true;
                    canReset.value = true;
                    //setTimeout(() => { showErrorBubble.value = false; errorMessage.value = ""; }, 4000);
                    serviceTicketCode.value = '';
                });
                
            return;
        } else if (bulkScanStep.value === 2) {
            console.log("Bulk scan - bulkServiceTicketBarcode - step2:", bulkServiceTicketBarcode.value, 'newValue:', newValue);
            if (bulkServiceTicketBarcode.value != null && bulkServiceTicketBarcode.value != newValue) {
                showErrorBubble.value = true;
                errorMessage.value = "Invalid service ticket scanned. Please scan the correct service ticket";
                playSound('error');
                serviceTicketCode.value = '';
                //force clear the FormKit input DOM value as a workaround
                nextTick(() => {
                    const ticketInput = document.getElementById('serviceTicketCodeInput');
                    if (ticketInput) ticketInput.value = '';
                });
                return;
            }
            console.log("Starting piece up with service ticket:", newValue, "and items:", itemsApplied.value);
            //if empty itemsApplied.value show alert and don't call API
            if (!itemsApplied.value || itemsApplied.value.length === 0) {
                //showErrorBubble.value = true;
                //errorMessage.value = "No garments scanned to piece up. Please scan garments before scanning the service ticket.";
                //playSound('error');
                stopScan().then(() => {
                    canStopScan.value = false; // Disable Stop Scan button when stream stops
                    canSartScan.value = true; // Enable Start Scan button when stream stops
                    canStartBulkScan.value = true; // Enable Start Bulk Scan button when stream stops
                    isStreamActive.value = false;
                }).catch((e) => {
                    errorMessage.value = e?.message || e;
                    showErrorBubble.value = true;
                });
                canReset.value = true;
               // setTimeout(() => { showErrorBubble.value = false; errorMessage.value = ""; }, 4000);
                serviceTicketCode.value = '';
                //force clear the FormKit input DOM value as a workaround           
                nextTick(() => {
                    const ticketInput = document.getElementById('serviceTicketCodeInput');
                    if (ticketInput) ticketInput.value = '';
                });
                return;
            }
            // Disable Stop Scan button immediately to prevent double submission
            canStopScan.value = false;
            stopScan().then(() => {
                RFIDService.startPieceUp(newValue, itemsApplied.value).then((response) => {
                    clearBulkScanTable();
                    itemsApplied.value = [];
                    isBulkScan.value = false;
                    bulkScanStep.value = 1;
                    canScanTicket.value = false;
                    canSartScan.value = true;
                    canStartBulkScan.value = true;
                    currentBulkOrder.value = null;
                    workflowMode.value = null;
                    console.log("[bulkScanStep.value === 2] Piece up response:", response);
                    if (response.data.data.ticket_complete) {
                        successMessage.value = "Bulk Scan stopped and items pieced up - the service ticket is now complete.";
                    } else {
                        successMessage.value = "Bulk Scan stopped and items pieced up.";
                    }
                    clearInputAndShowSuccess(successMessage.value, "serviceTicket");
                    serviceTicketCode.value = '';
                    itemsApplied.value = []; // Clear items applied for next scan
                    clearBulkScanTable();
                    showOrderDetails.value = false; // Hide order details after piece up
                    currentBulkOrder.value = null; // Clear current bulk order details
                    singleScanAllowed.value = true; // Reset single scan flag for next scan
                    showCompletesTicketBubble.value = false; // Reset completes ticket bubble for next scan
                    showNewAssignmentBubble.value = false; // Reset new assignment bubble for next scan
                    bulkServiceTicketBarcode.value = null; // Clear stored bulk service ticket barcode
                }).catch((e) => {
                    canReset.value = true;
                    if (e && e.response && e.response.status === 400) {
                        hideAllBubbles();
                        playSound('error');
                        showInvalidTicketBubble.value = true;
                        error_message_service_ticket.value = e.response.data?.message || 'Invalid service ticket.';
                    } else {
                        errorMessage.value = e?.message || e;
                        showErrorBubble.value = true;
                        playSound('error');
                       // setTimeout(() => { showErrorBubble.value = false; errorMessage.value = ""; }, 4000);
                    }
                    serviceTicketCode.value = '';
                });
            });
            return;
        }
    }
    // Scenario 2: Normal Scan
    if (workflowMode.value === 'normal') {
        console.log("Starting piece up with service ticket:", newValue, "and items:", itemsApplied.value);
        //if empty itemsApplied.value show alert and don't call API
        if (!itemsApplied.value || itemsApplied.value.length === 0) {
            showErrorBubble.value = true;
            errorMessage.value = "No garments scanned to piece up. Please scan garments before scanning the service ticket.";
            playSound('error');
            canReset.value = true;
            //setTimeout(() => { showErrorBubble.value = false; errorMessage.value = ""; }, 4000);
            serviceTicketCode.value = '';
            //force clear the FormKit input DOM value as a workaround           
             nextTick(() => {
                const ticketInput = document.getElementById('serviceTicketCodeInput');
                if (ticketInput) ticketInput.value = '';
            });
            return;
        }
        hideAllBubbles();
        showErrorBubble.value = false;
        showSuccessBubble.value = false;
        errorMessage.value = "";
        successMessage.value = "";
        showSseErrors.value = false;
        sseErrors.value = "";
        RFIDService.startPieceUp(newValue, itemsApplied.value).then((response) => {
            playSound('success');
            let msg = 'Garment pieced up.';
            if (response && response.data && response.data.data && response.data.data.ticket_complete) {
                msg = 'Garment pieced up - the service ticket is now complete.';
            }
            canScanTicket.value = true; // Keep Scan Ticket enabled to show success message
            canSartScan.value = false; // Disable Start Scan
            canStartBulkScan.value = false; // Disable Start Bulk Scan
            canStopScan.value = true; // Enable Stop Scan
            canReset.value = true; // Enable Clear
            workflowMode.value = null;
            clearInputAndShowSuccess(msg, "serviceTicket");
            serviceTicketCode.value = '';
            canScanCode.value = false; // Hide garment scan input after successful piece up
            showOrderDetails.value = false; // Hide order details after piece up
            currentBulkOrder.value = null; // Clear current bulk order details
            singleScanAllowed.value = true; // Reset single scan flag for next scan
            workflowMode.value = 'normal'
            itemsApplied.value = []; // Clear items applied for next scan
            clearBulkScanTable();
            showCompletesTicketBubble.value = false; // Reset completes ticket bubble for next scan
            showNewAssignmentBubble.value = false; // Reset new assignment bubble for next scan
        }).catch((e) => {
            canReset.value = true;
            if (e && e.response && e.response.status === 400) {
                hideAllBubbles();
                playSound('error');
                showInvalidTicketBubble.value = true;
                error_message_service_ticket.value = e.response.data?.message || 'Invalid service ticket.';
            } else {
                errorMessage.value = e?.message || e;
                showErrorBubble.value = true;
                playSound('error');
                //setTimeout(() => { showErrorBubble.value = false; errorMessage.value = ""; }, 4000);
            }
            serviceTicketCode.value = '';
        });
        return;
    }
    // Scenario 3: Ad-hoc (no button click)
    if (!workflowMode.value || workflowMode.value === 'ad-hoc') {
        RFIDService.startPieceUp(newValue, itemsApplied.value).then((response) => {
            let msg = 'Garment pieced up.';
            if (response && response.data && response.data.data && response.data.data.ticket_complete) {
                msg = 'Garment pieced up - the service ticket is now complete.';
            }
            canScanTicket.value = false;
            canSartScan.value = true;
            canStartBulkScan.value = true;
            workflowMode.value = null;
            hideAllBubbles();
            showOrderDetails.value = false;
            currentBulkOrder.value = null;
            canScanCode.value = true;
            focusElement('scanCodeInput');
            successMessage.value = msg;
            showSuccessBubble.value = true;
            serviceTicketCode.value = '';
            itemsApplied.value = []; // Clear items applied for next scan
            clearBulkScanTable();
            setTimeout(() => {
                showSuccessBubble.value = false;
                successMessage.value = '';
            }, 10000);
        }).catch((e) => {
            canReset.value = true;
            if (e && e.response && e.response.status === 400) {
                hideAllBubbles();
                playSound('error');
                showInvalidTicketBubble.value = true;
                error_message_service_ticket.value = e.response.data?.message || 'Invalid service ticket.';
            } else {
                errorMessage.value = e?.message || e;
                showErrorBubble.value = true;
                playSound('error');
                //setTimeout(() => { showErrorBubble.value = false; errorMessage.value = ""; }, 4000);
            }
            serviceTicketCode.value = '';
        });
        return;
    }
});


const getServiceTicketOrder = async (barcode, needPieceUp) => {

    console.log("currentServiceTicket.value before API call:", currentServiceTicket.value);
    try {
        //bedding or press only (bedding) => should be 1,75
        const defaultServiceId = process.env.VUE_APP_DEFAULT_SERVICE_TYPE_ID || 1;

        let response;
        if (needPieceUp) {
            response = await RFIDService.startPieceUp(barcode, itemsApplied.value);
            singleScanAllowed.value = true;
        } else {
            response = await ServiceTicket.getOrderByBarcode(barcode, defaultServiceId);
        }
        const ticketDetails = response.data.data;

        // Safely handle missing ticket_items
        if (response.data.data && Array.isArray(response.data.data.ticket_items)) {
            totalTags.value = response.data.data.ticket_items.length;
        } else {
            totalTags.value = 0;
            console.warn("ticket_items is undefined or not an array", response.data.data);
        }

        console.log("Service Ticket Details:", ticketDetails);
        console.log("Current Service Ticket Items:", response.data.data.ticket_items);
        if (currentServiceTicket.value && ticketDetails.service_ticket && ticketDetails.service_ticket.serviceticket_id !== currentServiceTicket.value) {
            playSound('error');
            hideAllBubbles();
            playSound('error');
            showInvalidTicketBubble.value = true;
            error_message_service_ticket.value = response.data.message || "";
        }
        else {
            playSound('success');
            //if Start Scan is still active
            if (isStreamActive.value) {
               clearScanCode("success", "hide");
                clearServiceTicketCode("success");
            } else {
               clearScanCode("success");
                clearServiceTicketCode("success", "hide");
            }

            hideAllBubbles();
            showOrderDetails.value = false;
            currentBulkOrder.value = null;
            if (needPieceUp) {
               successMessage.value = response.data.data.ticket_complete
                ? 'Garment pieced up - the service ticket is now complete.'
                : 'Garment pieced up';
                    showSuccessBubble.value = true;
                    playSound('success');
                    setTimeout(() => {
                        showSuccessBubble.value = false;
                        successMessage.value = '';
                    }, 10000);
            }

        }
        if (isBulkScan.value) {
            currentServiceTicket.value = ticketDetails.service_ticket.serviceticket_id;
            canStopBulkScan.value = true;
            console.log("Bulk scan started for order:", ticketDetails);
            currentBulkOrder.value = ticketDetails;
            //start stream to read tags
            if (!isStreamActive.value) {
                isStreamActive.value = true;
                console.log('[DEBUG] Opening new stream. isStreamActive set to true.');
                await startServerStream();
            } else {
                console.log('[DEBUG] Stream already active, not opening another.');
            }
            //startServerStream();
            canScanCode.value = false;
            // Keep canScanTicket true so alert remains visible
            canScanTicket.value = true;
            // Focus the service ticket input for next scan
            focusElement('serviceTicketCodeInput');
        } else if (ticketDetails.service_ticket && ticketDetails.service_ticket.order_id) {
            await loadOrderDetails(ticketDetails.service_ticket.order_id);
            serviceTicketCode.value = '';
            showOrderDetails.value = true;
            canStopBulkScan.value = true;
            // For non-bulk, hide ticket input after scan
            canScanTicket.value = false;
        } else {
            clearInputAndShowError(response.data.message || "Service Ticket not found: " + barcode, "serviceTicket");
        }
    } catch (error) {
        console.error("Error loading order details:", error);
        const message = error.response?.data?.message || "Error: Invalid/Outdated Service Ticket";
        clearInputAndShowError(message);
        playSound('error');
        hideAllBubbles();
        showInvalidTicketBubble.value = true;
        error_message_service_ticket.value = error.response?.data?.message || "";
        console.log("Error response data:", error.response?.data);
    }
};
const loadOrderDetails = async (orderID) => {
    try {
        const orderDetailsResponse = await OrderService.getOrder(orderID);
        console.log("Order Details:", orderDetailsResponse);
        /*if (response.data.status == "OK") {
         let orderDetails = response.data.result.details;
        }*/
        console.log("Order Details Response:", orderDetailsResponse.data.data);
        if (orderDetailsResponse.data.success == true) {
            orderDetails.value = createOrderDetailsModel(orderDetailsResponse.data.data.orders[0]);
            console.log("Order Details Value:", orderDetails.value);
        }
    } catch (error) {
        console.error("Error loading order details:", error);
    }
};
const goTo = (pageSection) => {
    switch (pageSection) {
        case "Dashboard":
            window.open(
                "/rfid/dashboard",
                "_self"
            );
            break;
        case "NewGarment":
            window.open(
                "/garmenttype",
                "_blank"
            );
            break;
        case "RefreshGarment":
            refreshgarment();
            break;
        case "startScan":
            startScan();
            break;
        case "startBulkScan":
            startBulkScan();
            break;
        case "StopScan":
            stopScan();
            break;
        case "Reset":
            resetScan();
            break;
        case "ApplyAll":
            applyAll();
            break;
    }
}
const zeroPad = (num, places) => String(num).padStart(places, '0')

const clearBulkScanTable = () => {
    if (bulkScanTableTimer) {
        clearTimeout(bulkScanTableTimer);
        bulkScanTableTimer = null;
    }

    tagsScanned.value = [];
};

const clearBulkInvalidGarments = () => {
    bulkInvalidGarments.value = [];
};

const scheduleBulkScanTableClear = () => {
    if (bulkScanTableTimer) {
        clearTimeout(bulkScanTableTimer);
    }

    bulkScanTableTimer = setTimeout(() => {
        tagsScanned.value = [];
        bulkScanTableTimer = null;
    }, 10000);
};

const buildScanRows = (sseData) => {
    const timestampSource = sseData.timestamp || sseData.data?.[0]?.timestamp || new Date().toISOString();
    const timestamp = formatLondon(timestampSource);
    const scanItems = Array.isArray(sseData.data)
        ? sseData.data.map(item => item?.data).filter(Boolean)
        : [sseData.data].filter(Boolean);

    return scanItems.map((scanItem, index) => ({
        garmentindex: zeroPad(tagsScanned.value.length + index + 1, 3),
        epcscanned: scanItem?.epc || `${sseData.tag || 'scan'}-${scanItem?.order_item_id || index}-${timestamp}`,
        tagtimestamp: timestamp,
        garmentType: scanItem?.garment_type || scanItem?.garment || 'Unknown Garment',
        isNew: true
    }));
};

const getGarmentTypeColorClass = (garmentType) => {
    const normalizedType = (garmentType || 'Unknown Garment').trim().toLowerCase();
    let hash = 0;

    for (let index = 0; index < normalizedType.length; index += 1) {
        hash = normalizedType.charCodeAt(index) + ((hash << 5) - hash);
    }

    return garmentTypeColorClasses[Math.abs(hash) % garmentTypeColorClasses.length];
};

// Function to add a scanned tag to the list -
const addToScanList = async (sseData, needSound = true) => {
    const hasNestedScanData = Array.isArray(sseData.data)
        ? sseData.data.some(item => item?.data)
        : !!sseData.data;

    if (!hasNestedScanData && (sseData.tag === undefined || sseData.tag === null || sseData.tag === "")) {
        //console.error("EPC Tag is empty or undefined");
        return false;
    }

    const newRows = buildScanRows(sseData);
    if (!newRows.length) {
        return false;
    }

    tagsScanned.value = [...newRows, ...tagsScanned.value].sort((leftRow, rightRow) => {
        return new Date(rightRow.tagtimestamp).getTime() - new Date(leftRow.tagtimestamp).getTime();
    });
    scheduleBulkScanTableClear();

    setTimeout(() => {
        tagsScanned.value = tagsScanned.value.map(scanRow => ({
            ...scanRow,
            isNew: false
        }));
    }, 3000);

    tagsScanned.value = [...tagsScanned.value];

    if (needSound) {
        playSound('success');
    }
}

const batchWrapperCodes = new Set(['SUCCESS_BATCH_RESULT', 'ERROR_BATCH_RESULT']);

const appendBulkInvalidGarment = (garmentData) => {
    if (!garmentData) {
        return;
    }

    const garmentTag = garmentData.tag || garmentData.epc;
    if (!bulkInvalidGarments.value.some(item => (item.tag || item.epc) === garmentTag)) {
        bulkInvalidGarments.value.push(garmentData);
    }
};

const processBatchWrapperEvent = async (sseData) => {
    const batchItems = Array.isArray(sseData.data)
        ? sseData.data
        : [sseData.data].filter(Boolean);
    let hasInvalidGarments = false;

    for (const batchItem of batchItems) {
        if (batchItem?.success === true && batchItem?.code === 'GARMENT_PIECED_UP' && batchItem?.data) {
            await handleScan({
                ...batchItem,
                data: batchItem.data,
                tag: batchItem.tag || batchItem.data?.epc || batchItem.data?.tag || sseData.tag,
                timestamp: batchItem.timestamp || batchItem.data?.timestamp || sseData.timestamp
            });
            continue;
        }

        if (batchItem?.success === false) {
            appendBulkInvalidGarment(batchItem.data || batchItem);
            hasInvalidGarments = true;
        }
    }

    if (hasInvalidGarments && invalidGarmentsModalInstance && typeof invalidGarmentsModalInstance.show === 'function') {
        playSound('error');
        invalidGarmentsModalInstance.show();
    }
};
// Function to handle stream events from the server and process the incoming RFID tags
const startServerStream = async () => {
    // Prevent multiple streams
    /*if (eventSource) {
        try { eventSource.close(); } catch (e) {}
        eventSource = null;
    }*/
    sseErrors.value = "";
    const authToken = VueCookies.get('epos2_token');
    
    let bulkParam = "";
    if (isBulkScan.value) {
        bulkParam = "&new_batch=1";
        //ServiceTicketID
        bulkParam += "&service_ticket_id=" + currentBulkOrder.value.service_ticket.serviceticket_id;
    }
    eventSource = new EventSource(process.env.VUE_APP_GO_API_BASE + "/api/rfid/stream?token=" + authToken + bulkParam);
    eventSource.onmessage = (event) => {
        
        pingSession();

        if (event.data && event.data.includes('heartbeat')) {
            sseErrors.value = "";
            showSseErrors.value = false;
            return;
        }
        const sseData = JSON.parse(event.data);
        const eventCode = sseData.code || sseData.data?.code;
        if (showNoOrderBubble.value || showNotFoundBubble.value || showErrorBubble.value || showInvalidTicketBubble.value) {
           playSound('error');
            alert ("Please press clear before scanning");
            return false
        }
        
        hideAllBubbles();

        if (!singleScanAllowed.value && !isBulkScan.value) {
            showSseErrors.value = true;
            sseErrors.value = "Only one tag can be scanned at a time. Please scan the service ticket to start a new scan";
            playSound('error');
            return;
        }
        hasMultipleScans.value = false;
        if (batchWrapperCodes.has(eventCode)) {
            processBatchWrapperEvent(sseData);
            return false;
        }
        // --- Error Handling ---
        if (!sseData.success) {
            const code = eventCode;
            const error = sseData.error;
            // Show error bubble and error message for all errors
            playSound('error');
            canReset.value = true;
            showSseErrors.value = false;
           /* 
            showSseErrors.value = true; 
           sseErrors.value = error;
            setTimeout(() => {
                showSseErrors.value = false;
                sseErrors.value = '';
            }, 5000);
            */
            // Error code specific handling
            switch (code) {
                case "MULTIPLE_TAGS":
                    showErrorBubble.value = true;
                    errorMessage.value = "You scanned more than 1 item, please try again.";
                    hasMultipleScans.value = true;
                    break;
                case "MAX_MULTIPLE_TAGS":
                    hasMultipleScans.value = true;
                    alertMessage.value = "You scanned more than 5 items, please try again.";
                    errorMessageTitle.value = "";
                    if (showErrorMessagesModal.value && typeof showErrorMessagesModal.value.show === 'function') {
                        showErrorMessagesModal.value.show();
                    }
                    break;
                case "GARMENT_NOT_IN_ORDER":
                    showNoOrderBubble.value = true;
                    //show details of the order item not found in the order in the error bubble
                    showOrderDetails.value = true;
                    orderDetails.value = createOrderDetailsModel(sseData.data, true);
                    currentScan.value = {
                        ID: sseData.data.garment_id,
                        Type: sseData.data.garment_type,
                        OrderItem: sseData.data.order_item_id,
                        EPC: sseData.data.epc || sseData.tag,
                        //hide qc buttons if garment not in order
                        no_order: true,
                        not_found: true
                    }
                    break;
                case "ORDER_ITEM_NOT_FOUND":
                    showNoOrderBubble.value = true;
                    //show details of the order item not found in the order in the error bubble
                    showOrderDetails.value = true;
                    orderDetails.value = createOrderDetailsModel(sseData.data, true);
                    currentScan.value = {
                        ID: sseData.data.garment_id,
                        Type: sseData.data.garment_type,
                        OrderItem: sseData.data.order_item_id,
                        EPC: sseData.data.epc || sseData.tag,
                        //hide qc buttons if garment not in order
                        no_order: true,
                        not_found: true
                    }
                    break;
                case "INVALID_TAG_FORMAT":
                    showNotFoundBubble.value = true;
                    break;
                case "GARMENT_NOT_FOUND":
                    showNotFoundBubble.value = true;
                    break;
                case "SERVICE_ITEM_NOT_FOUND":
                    showInvalidTicketBubble.value = true;
                    break;
                default:
                    showErrorBubble.value = true;
                    errorMessage.value = error || "An unknown error occurred while scanning. Please try again.";
            }
            return false;
        }

        // --- Success Handling ---
        showSseErrors.value = false;
        sseErrors.value = "";
        // Remove duplicates (same tag)
        if (!tagsScanned.value.some(item => item.epcscanned === sseData.tag)) {
            currentScan.value = sseData;
            handleScan(sseData);
        } else {
            console.log("Tag already exists");
        }
    };
    eventSource.onerror = function(error) {
        //playSound('error');
        console.error("Error:", error);
       // sseErrors.value =  "An error occurred. Session still active?";
       // showSseErrors.value = true;
    };
    eventSource.addEventListener("open", function(event) {
        console.log("Stream connection opened");
    });
}
const isNewAssignment = async (orderID, serviceTicketID) => {
    // Print the service ticket, then show the bubble (so it is not hidden by any state changes during print)
    await printServiceTicket(orderID, serviceTicketID);
    showNewAssignmentBubble.value = true;
    // Do not set a timeout to hide the bubble; it will remain until cleared/reset.
}
const handleScan = async (sseData) => {
    // Process the scanned tag data as needed
    await addToScanList(sseData);
    singleScanAllowed.value = false; // Disable further scans until the current one is processed
    console.log("Processing scanned tag:", sseData.data);
    const scanItems = Array.isArray(sseData.data)
        ? sseData.data.map(item => item?.data).filter(Boolean)
        : [sseData.data].filter(Boolean);
    if (!isBulkScan.value) {
        itemsApplied.value.push(sseData.data.order_item_id);
        if (!showOrderDetails.value) {
            showOrderDetails.value = true;
            orderDetails.value = createOrderDetailsModel(sseData.data);
            currentScan.value = {
                ID: sseData.data.garment_id,
                Type: sseData.data.garment_type,
                OrderItem: sseData.data.order_item_id,
                EPC: sseData.data.epc,
            }
            currentServiceTicket.value = sseData.data.service_ticket_id;

        }
    }

    console.log("[HANDLE SCAN] - piece up", sseData.data);
     console.log("[HANDLE SCAN] - piece up", sseData.data.piece_up);
    if (sseData.data?.piece_up?.is_first_assignment === true) {
        console.log("First assignment detected for order_id:", sseData.data.order_id, "and service_ticket_id:", sseData.data.service_ticket_id);
        await isNewAssignment(sseData.data.order_id, sseData.data.service_ticket_id);
    }
    if (sseData.data?.piece_up?.will_complete === true) {
        showCompletesTicketBubble.value = true;
    }
    if (isBulkScan.value) {
        console.log("Bulk scan - processing scanned tag:", sseData.data);
        if (scanItems.length) {
            scanItems.forEach(item => {
                if (item?.order_item_id && !itemsApplied.value.includes(item.order_item_id)) {
                    itemsApplied.value.push(item.order_item_id);
                }
            });
            console.log("[handleScan] Current itemsApplied after processing scanned tag:", itemsApplied.value);
        }
    }

    //disable stop / clear until the Service ticket is scanned - need to turn off the light
        canReset.value = true;
        canStopScan.value = false;
};
// Utility to check if an element is visible in the DOM
function isElementVisible(el) {
    return !!(el && el.offsetParent !== null);
}

const focusElement = (elementRef) => {
    nextTick(() => {
        // Only blur if the new element is visible and will be focused
        const inputEl = document.getElementById(elementRef);
        if (inputEl && isElementVisible(inputEl) && typeof inputEl.focus === 'function') {
            if (document.activeElement && typeof document.activeElement.blur === 'function') {
                document.activeElement.blur();
            }
            inputEl.focus();
            console.log("Successfully forced focus to the input element.");
        } else {
            // Silently skip if not found or not visible
            // console.warn("Input element not found or not visible for focus:", elementRef);
        }
    });
}
function showScanHint(message, type, button) {
    if (button === "scan") {
        scanCodeClass.value = 'error-message';
        scanCodeHint.value = message;
        canScanTicket.value = false;
        canScanCode.value = true;
        focusElement('scanCodeInput');
    } else if (button === "serviceTicket") {
        scanServiceTicketClass.value = 'error-message';
        scanServiceTicketHint.value = message;
        canScanTicket.value = true;
        canScanCode.value = false;
        focusElement('serviceTicketCodeInput');
    }
}
const startScan = async () => {
    console.log("[DEBUG] startScan called. isStreamActive:", isStreamActive.value);

    //if is visible ScanCode Input show showGarmentWarning and return false;
    if (canScanTicket.value) {
        showWarningBubble.value = true;

        return;
    }
    //will start the stream and the pieceup process with opening the folding ticket page in order to force the user to scan the service ticket and see the order details of the scanned garment before starting to scan more tags.
    //call goapi endpoint in order to start the scan
    canSartScan.value = false;
    canApply.value = false;
    canStopScan.value = true;
    canReset.value = true;
    canStartBulkScan.value = false;
    hasMultipleScans.value = false;
    canScanCode.value = true;
    console.log("Starting RFID scan stream...", canScanCode.value);
    canScanTicket.value = false;



    // Set workflow mode to 'normal' for standard piece up workflow
    workflowMode.value = 'normal';
    scanServiceTicketClass.value = 'success-message';
    scanServiceTicketHint.value = 'Scan Service Ticket';
    showScanHint('Scan Service Ticket', 'success', 'serviceTicket');
    itemsApplied.value = [];
    clearBulkScanTable();
    singleScanAllowed.value=true;
    hideAllBubbles();
    showErrorBubble.value = false;
     showSuccessBubble.value = false;
     errorMessage.value = "";
     successMessage.value = "";
     showOrderDetails.value = false;
     currentBulkOrder.value = null;
     showSseErrors.value = false;
     sseErrors.value = "";

    if (!isStreamActive.value) {
        isStreamActive.value = true;
        console.log('[DEBUG] Opening new stream. isStreamActive set to true.');
        await startServerStream();
        //start the reader to read the tags
        RFIDService.startScan()
            .catch(e => {
                console.log(e);
            });
    } else {
        console.log('[DEBUG] Stream already active, not opening another.');
    }

    console.log("Starting RFID scan stream...", canScanCode.value);
    focusElement('scanCodeInput');
}

const startBulkScan = async () => {
    console.log("start BULK scan");
    workflowMode.value = 'bulk';
    //call goapi endpoint in order to start the scan
    canSartScan.value = false;
    canApply.value = false;
    canStopScan.value = true;
    canReset.value = true;
    isBulkScan.value = true;
    canScanCode.value = false;
    canScanTicket.value = true;
    serviceTicketCode.value = '';
    focusElement('serviceTicketCodeInput');
    scanServiceTicketClass.value = 'success-message';
    scanServiceTicketHint.value = 'Scan Service Ticket';
     itemsApplied.value = [];
    clearBulkScanTable();
    singleScanAllowed.value=false;
    hideAllBubbles();
    showErrorBubble.value = false;
     showSuccessBubble.value = false;
     errorMessage.value = "";
     successMessage.value = "";
     showOrderDetails.value = false;
     currentBulkOrder.value = null;
     showSseErrors.value = false;
     sseErrors.value = "";
    currentServiceTicket.value = null;
    //stream will start ONLY after the ServiceTicket is scanned and validated 
    //in order to avoid streaming unnecessary tags if the user just wants to do a normal piece up without bulk scan. 
}

const stopScan = async () => {
    // Stop the reader/stream
    if (eventSource) {
        try { eventSource.close(); } catch (e) {}
        eventSource = null;
        isStreamActive.value = false;
    }
    await RFIDService.stopScan().catch(() => {});
    //"Stop Scan" will stop the reader, reset workflowMode to 'ad-hoc',
    //  clear all UI and state, and disable the Stop Scan button.

    // Reset workflow state
    errorMessage.value = "";
     successMessage.value = "";
     showErrorBubble.value = false;
     showSuccessBubble.value = false;
    workflowMode.value = 'ad-hoc';
    bulkScanStep.value=1;
    // Clear all UI and state
    showSseErrors.value = false;
    sseErrors.value = "";
    isBulkScan.value = false;
    canStartBulkScan.value = true;
    scanCode.value = '';
    canScanCode.value = true;
    serviceTicketCode.value = '';
    canScanTicket.value = false;
    canReset.value = false;
    canSartScan.value = true;
    canStopScan.value = false;
    hideAllBubbles();
    showOrderDetails.value = false;
    currentBulkOrder.value = null;
    itemsApplied.value = [];
    clearBulkScanTable();
    clearBulkInvalidGarments();
    singleScanAllowed.value=true;
    // Autofocus scanCode input
    focusElement('scanCodeInput');
}

const resetScan = async () => {
    if (isResetting.value) {
        return;
    }

    isResetting.value = true;

    // Only hide all bubbles, show ScanCode input, autofocus, and disable Clear
    //try to stop all lights
    try {
        await RFIDService.stopSmartshelfLights();
    } catch (e) {
        console.log("Error stopping smartshelf lights during reset:", e);
    } finally {
        hideAllBubbles();
        showOrderDetails.value = false;
        currentBulkOrder.value = null;
        console.log("Resetting scan state. Current workflow mode:", workflowMode.value);
        if (!workflowMode.value || workflowMode.value === 'ad-hoc') {
            canScanCode.value = true;
            scanCode.value = '';
            serviceTicketCode.value = '';
            canScanTicket.value = false;
            focusElement('scanCodeInput');
        } else {
            canScanTicket.value = true;
            canScanCode.value = false;
            focusElement('serviceTicketCodeInput');
        }
        canReset.value = false;
        itemsApplied.value = [];
        clearBulkScanTable();
        clearBulkInvalidGarments();
        singleScanAllowed.value=true;
        canStopScan.value = true;
        isResetting.value = false;
    }

    console.log("Resetting scan state END. Current workflow mode:", workflowMode.value);
}
const hideAllBubbles = () => {
    showNewAssignmentBubble.value = false;
    showCompletesTicketBubble.value = false;
    showNoOrderBubble.value = false;
    showNotFoundBubble.value = false;
    showInvalidTicketBubble.value = false;
    showWarningBubble.value = false;
    showSseErrors.value = false;
    sseErrors.value = "";
    showErrorBubble.value = false;
    errorMessage.value = "";
    showSuccessBubble.value = false;
    successMessage.value = "";
}

const resetPendingGarmentAfterQcFail = () => {
    currentScan.value = {};
    currentServiceTicket.value = null;
    showOrderDetails.value = false;
    currentBulkOrder.value = null;
    itemsApplied.value = [];
    clearBulkScanTable();
    singleScanAllowed.value = true;

    if (!isStreamActive.value && (!workflowMode.value || workflowMode.value === 'ad-hoc')) {
        workflowMode.value = 'ad-hoc';
        canScanCode.value = true;
        canScanTicket.value = false;
        canSartScan.value = true;
        canStartBulkScan.value = true;
        canStopScan.value = false;
        clearScanCode('success');
        clearServiceTicketCode('success', 'hide');
        focusElement('scanCodeInput');
        return;
    }

    clearServiceTicketCode('success');
    focusElement('serviceTicketCodeInput');
};

const failQcCleaning = async () => {
    console.log('Fail QC (Cleaning)  for garment:')
    try {
        await OrderService.failQCGarment(currentScan.value.OrderItem, 'cleaning');
        hideAllBubbles();
        qcFailMessage.value = 'Garment failed for Cleaning';
        showQcFailBubble.value = true;
        resetPendingGarmentAfterQcFail();
        setTimeout(() => {
            showQcFailBubble.value = false;
        }, 3000);
        if (workflowMode.value === 'ad-hoc') {
            canStopScan.value = false;
        } else {
            canStopScan.value = true;
        }
        
        canReset.value = true;
         
    } catch (e) {
        console.log("Error failing garment for Cleaning:", e);
    }
}

const failQcRepair = async () => {
    console.log('Fail QC (Repair)  for garment:')
    try {
        await OrderService.failQCGarment(currentScan.value.OrderItem, 'repair');
        hideAllBubbles();
        qcFailMessage.value = 'Garment failed for Repair';
        showQcFailBubble.value = true;
        resetPendingGarmentAfterQcFail();
        setTimeout(() => {
            showQcFailBubble.value = false;
        }, 3000);
        if (workflowMode.value === 'ad-hoc') {
            canStopScan.value = false;
        } else {
            canStopScan.value = true;
        }
        canReset.value = true;
    } catch (e) {
        console.log("Error failing garment for Repair:", e);
    }
}

function pingSession() {
    let userId = VueCookies.get('epos2_userid');
    let idToken = VueCookies.get('epos2_token');
    let userWorkstation = VueCookies.get('epos2_workstationid');

    VueCookies.set('epos2_token', idToken);
    VueCookies.set('epos2_userid', userId);
    VueCookies.set('epos2_workstationid', userWorkstation);
    console.log('API called at', new Date());
}
onMounted(() => {
    showAlertMessagesModal.value = new bootstrap.Modal('#showAlertMessagesModal', {});
    showErrorMessagesModal.value = new bootstrap.Modal(showErrorMessagesModalEl.value, {});
    invalidGarmentsModalInstance = new bootstrap.Modal(showInvalidGarmentsModalEl.value, {});
    if (showInvalidGarmentsModalEl.value) {
        showInvalidGarmentsModalEl.value.addEventListener('hidden.bs.modal', clearBulkInvalidGarments);
    }
    // Autofocus scanCode input if visible on mount
    if (canScanCode.value) {
        focusElement('scanCodeInput');
    }
});
</script>

<style scoped>
.main-section>h1:first-child {
    background: var(--pieceup-bg-color);
}

.btn-stop-scan {
    color: #fff;
   background-color: #dc3545!important;
    border-color:  #dc3545!important;
}
.rfid-action-buttons {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        width: 100%;
}

@media (max-width: 700px) {
    .rfid-action-buttons {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
    }
    .rfid-action-buttons > * {
        width: 100%;
        min-width: 0;
    }
}

.error-message {
    color: var(--red-color);
    font-weight: bold;
}

.highlight-row {
    background-color: #ffeeba !important;
    /* or any highlight color */
    transition: background-color 0.5s;
}

.success-message {
    color: #198754;
    font-weight: bold;
}

.modal-note {
    font-size: 14px;
    color: #666;
    font-style: italic;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 0;
    padding-top: 16px;
    border-top: 1px solid #eee;
}

/* Garment Information Styles */
.garment-info {
    margin-top: 50px;
    padding: 24px 32px;
    background-color: #f9f9f9;
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    align-self: center;
    width: fit-content;
    min-width: 600px;
    margin: 50px auto;
}

.garment-info--bulk {
    margin: 0;
    min-width: 0;
    width: 100%;
    align-self: flex-start;
}

.garment-info--bulk .garment-info-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px 28px;
}

.garment-info--bulk .info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
}

.garment-info--bulk .info-label {
    font-size: 15px;
    margin-bottom: 0;
}

.garment-info--bulk .info-value {
    font-size: 18px;
    line-height: 1.35;
    align-items: flex-start;
}

.bulk-scan-layout {
    width: fit-content;
    margin: 50px auto;
}

.bulk-scan-layout--active {
    width: 100%;
    display: grid;
    grid-template-columns: minmax(420px, 520px) minmax(520px, 720px);
    justify-content: center;
    align-items: start;
    gap: 44px;
}

.bulk-scan-table-panel {
    margin-top: 0;
    padding: 16px 18px 18px;
    background: #ffffff;
    border: 2px solid #101010;
    border-radius: 12px;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
    width: 100%;
    max-width: 720px;
    align-self: flex-start;
}

.bulk-scan-table-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 16px;
}

.bulk-scan-table-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1f1f1f;
}

.bulk-scan-table-subtitle {
    margin: 4px 0 0;
    color: #626262;
    font-size: 14px;
}

.bulk-scan-clear-btn {
    min-width: 74px;
    border: 1px solid #117a8b;
    color: #117a8b;
    background: #e6fbff;
    font-weight: 700;
}

.bulk-scan-clear-btn:disabled {
    opacity: 0.45;
}

.bulk-scan-table-shell {
    overflow-x: auto;
}

.bulk-scan-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    min-width: 400px;
}

.bulk-scan-table th,
.bulk-scan-table td {
    padding: 10px 12px;
    text-align: left;
    border-bottom: 1px solid #d9d9d9;
}

.bulk-scan-table th {
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #4f4f4f;
    background: #f7f7f7;
}

.bulk-scan-row td:first-child {
    font-weight: 700;
    width: 72px;
}

.bulk-scan-row td:nth-child(3) {
    white-space: nowrap;
}

.bulk-scan-row.bulk-scan-type-0 {
    background: #eef8ff;
    color: #0b5cab;
}

.bulk-scan-row.bulk-scan-type-1 {
    background: #fff6e7;
    color: #b05a00;
}

.bulk-scan-row.bulk-scan-type-2 {
    background: #eefbef;
    color: #12703f;
}

.bulk-scan-row.bulk-scan-type-3 {
    background: #fff0f3;
    color: #b4234d;
}

.bulk-scan-row.bulk-scan-type-4 {
    background: #f5f2ff;
    color: #5a36b1;
}

.bulk-scan-row.bulk-scan-type-5 {
    background: #eefbfa;
    color: #0d6b67;
}

.bulk-scan-empty-state {
    text-align: center;
    color: #6c757d;
    padding: 32px 16px;
}

@media (max-width: 1100px) {
    .bulk-scan-layout--active {
        grid-template-columns: 1fr;
    }

    .bulk-scan-table-panel {
        margin-top: 0;
        max-width: none;
    }
}

.garment-info-grid {
    display: grid;
    grid-template-columns: auto auto;
    gap: 12px 50px;
}

.info-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
}

.info-label {
    font-size: 18px;
    color: #666;
    font-weight: 500;
    white-space: nowrap;
}

.info-value {
    font-size: 20px;
    color: #333;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 10px;
}

.express-flag {
    background-color: #dc3545;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 6px;
}

/* QC Fail Buttons */
.qc-buttons {
    display: flex;
    justify-content: center;
    gap: 40px;
    margin-top: 24px;
}

.btn-fail-cleaning {
    background-color: #990000;
    color: #fff;
    flex: 0;
    min-width: 220px;
    max-width: 280px;
    white-space: nowrap;
}

.btn-fail-repair {
    background-color: #741B47;
    color: #fff;
    flex: 0;
    min-width: 220px;
    max-width: 280px;
    white-space: nowrap;
}

/* Success Bubble */
.success-bubble {
    background-color: #fff;
    color: #28a745;
    padding: 16px 32px;
    border-radius: 10px;
    border: 2px solid #28a745;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    align-self: center;
    width: 50%;
    margin: 28px auto;
}

/* Warning Bubble */
.warning-bubble {
    background-color: #fff;
    color: #dc3545;
    padding: 16px 32px;
    border-radius: 10px;
    border: 2px solid #dc3545;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    align-self: center;
    width: 50%;
    margin: 28px auto;
}

/* New Assignment Bubble */
.new-assignment-bubble {
    background-color: #fff;
    color: #0d6efd;
    padding: 16px 32px;
    border-radius: 10px;
    border: 2px solid #0d6efd;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    align-self: center;
    width: 50%;
    margin: 28px auto;
}

/* Completes Ticket Bubble */
.completes-ticket-bubble {
    background-color: #fff;
    color: #28a745;
    padding: 16px 32px;
    border-radius: 10px;
    border: 2px solid #28a745;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    align-self: center;
    width: 50%;
    margin: 28px auto;
}

/* QC Fail Bubble */
.qc-fail-bubble {
    background-color: #fff;
    color: #0d6efd;
    padding: 16px 32px;
    border-radius: 10px;
    border: 2px solid #0d6efd;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    align-self: center;
    width: 50%;
    margin: 28px auto;
}

/* No Order Bubble */
.no-order-bubble {
    background-color: #fff;
    color: #dc3545;
    padding: 16px 32px;
    border-radius: 10px;
    border: 2px solid #dc3545;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    align-self: center;
    width: 50%;
    margin: 28px auto;
}

/* Not Found Bubble */
.not-found-bubble {
    background-color: #fff;
    color: #dc3545;
    padding: 16px 32px;
    border-radius: 10px;
    border: 2px solid #dc3545;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    align-self: center;
    width: 50%;
    margin: 28px auto;
}

/* Invalid Ticket Bubble */
.invalid-ticket-bubble {
    background-color: #fff;
    color: #dc3545;
    padding: 16px 32px;
    border-radius: 10px;
    border: 2px solid #dc3545;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    align-self: center;
    width: 50%;
    margin: 28px auto;
}
.modal-message {
  font-size: 18px;
  font-weight: 600;
  color: #dc3545;
  margin-bottom: 20px;
  text-align: center;
}

.invalid-garments-list {
  list-style: none;
  padding: 0;
  margin: 16px 0;
}

.invalid-garments-list li {
  padding: 12px 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 8px;
  font-size: 16px;
}

.invalid-garments-list li:last-child {
  margin-bottom: 0;
}

.garment-link {
  color: #0d6efd;
  text-decoration: underline;
  cursor: pointer;
}

.garment-link:hover {
  color: #0a58ca;
}

</style>
